import { useMutation } from '@gogame/query';

import { createCategory } from 'scenes/Influencers/InfluencersChannels/sources/categories';

import { CATEGORIES } from '../constants';
import { create, grid } from '../queryKeyFactory';

export const useCreateCategory = () => {
  const createMutation = useMutation(create(), createCategory, {
    successMessage: () => 'Category created',
    refreshOptions: {
      queryKey: grid(CATEGORIES),
    },
  });
  return [createMutation.mutateAsync, createMutation];
};
